import SectionTitle from "./components/custom/SectionTitle";

require("./bootstrap");

window.Vue = require("vue");

//Bootstrap VUE
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

//Toast
import Toasted from "vue-toasted";
Vue.use(Toasted);

//Swiper(Carrousel)
import VueAwesomeSwiper from "vue-awesome-swiper2";
Vue.use(VueAwesomeSwiper);
import "swiper/dist/css/swiper.css";

//VueFilters(Filtros pre definidos)
import Vue2Filters from "vue2-filters";
Vue.use(Vue2Filters);

import VueCookies from "vue-cookies-reactive";
Vue.use(VueCookies);

import Select2 from "./components/select2";

//Ziggy
import route from "ziggy";
import { Ziggy } from "./ziggy";

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy)
    }
});
Vue.component(
    "cookie-alert",
    require("./components/partials/cookies/CookieAlert.vue").default
);
Vue.component(
    "cookie-preferences",
    require("./components/partials/cookies/CookiePreferences.vue").default
);
Vue.component(
    "sidebar",
    require("./components/partials/Sidebar.vue").default
);
Vue.component(
    "load-spiner",
    require("./components/partials/LoadSpinerComponent.vue").default
);
Vue.component(
    "newsletter-block",
    require("./components/partials/NewsletterBlockComponent.vue").default
);
Vue.component(
    "compartir-fotos-block",
    require("./components/partials/CompartirFotosComponent.vue").default
);
Vue.component(
    "windows-info",
    require("./components/partials/WindowsInfoComponent.vue").default
);
Vue.component(
    "help-contact-block",
    require("./components/partials/ContactBlockComponent.vue").default
);
Vue.component(
    "modal-block",
    require("./components/partials/ModalBlockComponent.vue").default
);

Vue.component(
    "details-product",
    require("./components/product/DetailsProductComponent.vue").default
);
Vue.component(
    "image-product",
    require("./components/product/ImageProductComponent.vue").default
);

Vue.component(
    "index-cart",
    require("./components/cart/IndexCartComponent.vue").default
);
Vue.component(
    "desglose-order-cart",
    require("./components/cart/partials/DesgloseOrdersCartComponent.vue")
        .default
);
Vue.component(
    "share-ship-cart",
    require("./components/cart/partials/ShareShipComponent.vue").default
);
Vue.component(
    "product-cart-block",
    require("./components/cart/partials/ProductBlockCartComponent.vue").default
);
Vue.component(
    "orders-shippings-cart",
    require("./components/cart/ShipinngCartComponent.vue").default
);
Vue.component(
    "component-shipping-cart",
    require("./components/cart/partials/ShipWeekBlockCartComponent.vue").default
);
Vue.component(
    "address-create-cart",
    require("./components/cart/partials/AddressCreateCartComponent.vue").default
);
Vue.component(
    "address-edit-cart",
    require("./components/cart/partials/AddressEditCartComponent.vue").default
);

Vue.component(
    "account-datos",
    require("./components/account/DatosComponent.vue").default
);
Vue.component(
    "account-saldos",
    require("./components/account/SaldoComponent.vue").default
);

Vue.component(
    "account-pedidos",
    require("./components/account/PedidosComponent.vue").default
);
Vue.component(
    "pedido-line",
    require("./components/account/orders/PedidoLineComponent.vue").default
);
Vue.component(
    "pedido-editar",
    require("./components/account/orders/edit/PedidoEditComponent.vue").default
);
Vue.component(
    "pedido-shipping",
    require("./components/account/orders/edit/ShipBlockOrderComponent.vue")
        .default
);
Vue.component(
    "pedido-line-edit",
    require("./components/account/orders/edit/PedidoLineEditComponent.vue")
        .default
);
Vue.component(
    "pedido-line-medida-edit",
    require("./components/account/orders/edit/PedidoLineMedidaEditComponent.vue")
        .default
);
Vue.component(
    "pedido-edit-add-item",
    require("./components/account/orders/edit/ProductAvaiableComponent.vue")
        .default
);
Vue.component(
    "pedido-edit-item-block",
    require("./components/account/orders/edit/ProductBlockComponent.vue")
        .default
);

Vue.component(
    "address-create",
    require("./components/account/address/AddressCreateComponent.vue").default
);
Vue.component(
    "account-direcciones",
    require("./components/account/DireccionesComponent.vue").default
);

Vue.component(
    "week-component",
    require("./components/available_section/AvailableWeekComponent.vue").default
);
Vue.component(
    "product-block",
    require("./components/available_section/ProductBlockComponent.vue").default
);
Vue.component(
    "filter-products",
    require("./components/available_section/partials/FilterComponent.vue")
        .default
);
Vue.component(
    "contact-block",
    require("./components/available_section/partials/ContactComponent.vue")
        .default
);

Vue.component(
    "share-opinions",
    require("./components/product/ShareOpinionsComponent.vue").default
);

Vue.component(
    "dudas-component",
    require("./components/help/DudasComponent").default
);

Vue.component(
    "encuesta-envio",
    require("./components/valoraciones/EncuestaEnvioComponent.vue").default
);

Vue.component(
    "encuesta-variedad",
    require("./components/valoraciones/EncuestaVariedadesComponent").default
);

Vue.component(
    "devolver-bandejas",
    require("./components/account/DevolverBandejas").default
);

Vue.component("select2", Select2);
Vue.component("section-title", SectionTitle);
Vue.component(
    "valoraciones-show",
    require("./components/custom/ValoracionesShow").default
);

import TypeSelect from "./components/custom/TypeSelect";
import WeekSelect from "./components/custom/WeekSelect";
import VarietySelect from "./components/custom/VarietySelect";
import InjertoTypeSelect from "./components/custom/InjertoTypeSelect";
import InjertoSelect from "./components/custom/InjertoSelect";
import InfiniteLoading from "vue-infinite-loading";
import QuantitySelect from "./components/custom/QuantitySelect";
import VarietyInfoModal from "./components/custom/VarietyInfoModal";
import ProductBlockVarietyInfoModal from "./components/custom/ProductBlockVarietyInfoModal";
import SummaryMain from "./components/custom/SummaryMain";

Vue.component("type-select", TypeSelect);
Vue.component("week-select", WeekSelect);
Vue.component("variety-select", VarietySelect);
Vue.component("injerto-type-select", InjertoTypeSelect);
Vue.component("injerto-select", InjertoSelect);
Vue.component("quantity-select", QuantitySelect);
Vue.component("variety-info-modal", VarietyInfoModal);
Vue.component("product-variety-info-modal", ProductBlockVarietyInfoModal);
Vue.component("summary-main", SummaryMain);

Vue.component("campana-notificaciones", CampanaNotificaciones);

require("./back/pedidos/euroFormatter");

Vue.mixin({
    methods: {
        formatMoney: window.formatMoney,
        shuffle(array) {
            let counter = array.length;

            // While there are elements in the array
            while (counter > 0) {
                // Pick a random index
                let index = Math.floor(Math.random() * counter);

                // Decrease counter by 1
                counter--;

                // And swap the last element with it
                let temp = array[counter];
                array[counter] = array[index];
                array[index] = temp;
            }

            return array;
        }
    }
});

Vue.use(InfiniteLoading, {
    slots: {
        noResults: "No hay datos",
        noMore: "No hay más datos :)"
    },
    props: {
        spinner: "spiral"
    }
});

Vue.filter("getAhorro", function(
    value,
    unidades,
    importe = false,
    tipo_cliente = 0
) {
    var tasa_ahorro = 0;
    if (tipo_cliente == 1) {
        tasa_ahorro = 0;
    } else if (unidades >= 12) {
        tasa_ahorro = 1;
    } else if (unidades >= 7) {
        tasa_ahorro = 0.66;
    } else if (unidades >= 3) {
        tasa_ahorro = 0.33;
    }
    if (importe) {
        return (value / 1.1 - unidades * tasa_ahorro) * 1.1;
    } else {
        return unidades * tasa_ahorro;
    }
});

Vue.filter("round", function(value) {
    return Math.round(value * 100) / 100;
});

Vue.filter("subtitleEnvio", function(yearWeek) {
    let year = yearWeek.substring(0, 4);
    let week = yearWeek.substring(5);
    var miercoles = moment()
        .locale("es")
        .year(year)
        .week(week)
        .isoWeekday(3);

    return `Entrega el próximo miércoles ${miercoles.format(
        "DD"
    )} de ${miercoles.format("MMMM")}`;
});

Vue.filter("weekEnvio", function(yearWeek) {
    return yearWeek.substring(5);
});

Vue.prototype.window = window;

import StarRating from "vue-star-rating";
import moment from "moment";
import "moment/locale/es";
import Vue from "vue";
window.moment = moment;

import store from "./store";
import CampanaNotificaciones from "./components/partials/CampanaNotificaciones";

import { mapMutations } from "vuex";

const app = new Vue({
    el: "#app",
    components: {
        Window,
        StarRating
    },
    store,
    data: {
        tipo_cliente: null,
        cart: "",
        orders: "",
        customLines: [],
        enviosByWeek: [],
        recargosEquivalenciaByWeek: [],
        weeks: "",
        agrotienda: false,
        filters: {
            ordenar: [],
            especie: [],
            mote: [],
            zona: [],
            formato: [],
            eco: true,
            oferta: false,
            buscarCadena: ""
        },
        provincia: "",
        provinciasRecomendadas: [],
        showMenuProvincias: false,
        isApplyFilters: false,

        saldo_cliente: 0,
        formaPagoSelected: null
    },
    mounted() {
        this.loadCartInfo();

        this.isAgro();

        this.$on("loadCartInfo", function() {
            this.loadCartInfo();
        });

        this.$on("loadFilterProducts", function(filter_name, values) {
            this.filters[filter_name] = values;
        });

        this.$on("toggleFilterProducts", function(filter, active) {
            this.toggleFilterProducts(filter, active);
        });
        this.$nextTick(function() {
            // Code that will run only after the
            // entire view has been rendered
            ga("send", "pageview");
        });
    },
    computed: {
        linesCompositeByWeeks() {
            let lines = [];
            let orders = this.orders;
            for (let yearWeek in orders) {
                if (orders.hasOwnProperty(yearWeek)) {
                    let weekOrders = this.orders[yearWeek];
                    let yearIso = yearWeek.substring(0, 4);
                    let weekIso = yearWeek.substring(5);
                    lines.push({
                        week: weekIso,
                        year: yearIso,
                        weekYear: yearWeek,
                        disponibleLines: weekOrders.lineas,
                        customLines: weekOrders.lineasCustom,
                        envios: weekOrders.envio,
                        recargo_e: weekOrders.recargo_e
                    });
                }
            }
            return lines;
        }
    },
    watch: {
        filters: {
            handler: function() {
                this.isFiltersApply();
            },
            deep: true
        },
        provincia: function() {
            if (this.provincia.length >= 3) {
                this.autocompleteProvincia();
            } else {
                this.provinciasRecomendadas = [];
            }
        }
    },
    methods: {
        ...mapMutations("disponible", ["setWeeks"]),
        loadCartInfo: function() {
            axios
                .get("/carrito/get-info")
                .then(response => {
                    this.cart = response.data.cart;
                    this.orders = response.data.orders;
                    this.customLines = response.data.custom_lines;
                    this.enviosByWeek = response.data.envios_by_week;
                    this.recargosEquivalenciaByWeek =
                        response.data.recargos_e_by_week;
                    this.weeks = response.data.weeks;
                    this.setWeeks(this.weeks);
                    this.saldo_cliente = response.data.saldo_cliente;
                    this.tipo_cliente = response.data.tarifa;
                    if (response.data.tarifa == 1) {
                        this.filters.eco = false;
                    }
                    if (response.data.register_agro) {
                        this.$refs["register-agrotienda"].$refs[
                            "register-agrotienda"
                        ].show();
                    }
                    if (response.data.error_pago) {
                        this.$refs["error-pago"].$refs["error-pago"].show();
                    }
                    if (response.data.pago_completado) {
                        this.$refs["pago-completado"].$refs[
                            "pago-completado"
                        ].show();
                    }
                    if (response.data.pago_saldo_completado) {
                        this.$refs["pago-saldo-completado"].$refs[
                            "pago-saldo-completado"
                        ].show();
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        },
        toggleShowInput: function(event) {
            var input_type = event.target.previousElementSibling.type;
            if (input_type == "password") {
                event.target.previousElementSibling.type = "text";
                event.target.innerText = "Ocultar";
            } else {
                event.target.previousElementSibling.type = "password";
                event.target.innerText = "Mostrar";
            }
        },
        setAgrotienda: function(value) {
            this.agrotienda = value;
        },
        setZona: function(value) {
            var index = this.filters.zona.indexOf(value);
            if (index >= 0) {
                this.filters.zona.splice(index, 1);
            } else {
                this.filters.zona.push(value);
            }
        },
        setOferta: function() {
            if (this.filters.oferta) {
                this.filters.oferta = false;
            } else {
                this.filters.oferta = true;
            }
        },
        isFiltersApply: function() {
            for (const [key, value] of Object.entries(this.filters)) {
                if (key != "eco" && key != "zona" && value.length > 0) {
                    this.isApplyFilters = true;
                    return;
                }
            }
            this.isApplyFilters = false;
        },
        toggleFilterProducts: function(filter, active) {
            var filtros_despl = this.$root.$children.filter(child => {
                return (
                    child.$options.name === "filter-products" && child.active
                );
            });
            for (var i = 0; i < filtros_despl.length; i++) {
                filtros_despl[i].active = false;
            }

            if (active) {
                filter.active = false;
            } else {
                filter.active = true;
            }
        },
        deleteFilter: function(filter, id = null) {
            if (filter != "buscarCadena") {
                var filtro = this.filters[filter].find(i => i.id == id);
                var index = this.filters[filter].indexOf(filtro);
                this.filters[filter].splice(index, 1);
            } else {
                this.filters["buscarCadena"] = "";
            }
        },
        deleteFilterAll: function() {
            this.filters["ordenar"].splice(0, this.filters["ordenar"].length);
            this.filters["especie"].splice(0, this.filters["especie"].length);
            this.filters["mote"].splice(0, this.filters["mote"].length);
            this.filters["formato"].splice(0, this.filters["formato"].length);
            this.filters["zona"].splice(0, this.filters["zona"].length);
            this.filters["buscarCadena"] = "";
            this.filters["oferta"] = "";
        },
        autocompleteProvincia: function() {
            axios
                .post("/autocomplete/provincia/", {
                    filter: this.provincia
                })
                .then(response => {
                    this.provinciasRecomendadas = response.data.provincias;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        setProvincia: function(provincia) {
            axios
                .post("/provincia-zona/", {
                    estacion: provincia.IDEstacion
                })
                .then(response => {
                    this.setZona(response.data.zona);
                    this.showMenuProvincias = false;
                    this.provincia =
                        provincia.Poblacion +
                        ", " +
                        provincia.Provincia +
                        "(" +
                        provincia.CP +
                        ")";
                })
                .catch(e => {
                    console.log(e);
                });
        },
        openInfoWindow: function(ventana) {
            var window = this.$refs[ventana];
            window.active = !window.active;
        },
        isAgro: function() {
            if ($("#isAgro").val() == "1") {
                this.agrotienda = true;
                $("#radio_agrotienda").click();
            } else {
                this.agrotienda = false;
            }
        },
        clearProvincia: function() {
            this.provincia = "";
        },
        setFormaPago(value) {
            this.formaPagoSelected = value;
        },
        customLinesByWeek(yearWeek) {
            let orders = [];
            if (this.orders) {
                let ordersWeek = this.orders[yearWeek];
                if (ordersWeek) {
                    orders.push(...ordersWeek.lineasCustom);
                }
            }
            return orders;
        },
        ordersByWeek(yearWeek) {
            let orders = [];
            if (this.orders) {
                let ordersWeek = this.orders[yearWeek];
                if (ordersWeek) {
                    orders.push(...ordersWeek.lineas);
                }
            }
            return orders;
        }
    }
});
